import { useEffect, useState } from "react";
import { postAxios } from "../../util/apiCall";
import { today } from "../../util/formatDate";
import {
  switchDotsAndCommas,
  numberWithCommas,
  formatDot,
  hasRole,
} from "../../util/utilFunction";
import axios from "axios";

import moment from "moment";
import XLSX from "xlsx-js-style";

export const useInventory = () => {
  const dataAuth = localStorage.getItem("auth");
  const dataUser = JSON.parse(dataAuth);

  const [companyPick, setCompanyPick] = useState("GS");
  const [dataInventory, setDataInventory] = useState();
  const [dataListCrusher, setDataListCrusher] = useState();
  const [dataListPewarna, setDataListPewarna] = useState();
  const [dataBarangJadi, setDataBarangJadi] = useState();
  const [subMenu, setSubMenu] = useState("bahanBaku");

  // FIX: counter, bukan boolean. Tidak perlu di-reset ke false di dalam effect,
  // jadi effect tidak jalan dua kali.
  const [refreshKey, setRefreshKey] = useState(0);
  const triggerRefresh = () => setRefreshKey((k) => k + 1);

  const [dataHistorySearch, setDataHistorySearch] = useState();
  const [popUpSearch, setPopUpSearch] = useState(false);
  const [dataPickHistory, setDataPickHistory] = useState();
  const [bulanPickHistory, setBulanPickHistory] = useState(
    moment().utcOffset("+0700").month() + 1
  );
  const [tahunPickHistory, setTahunPickHistory] = useState(
    moment().utcOffset("+0700").year()
  );

  const [paramSearch, setParamSearch] = useState("material");
  const [valueSearch, setValueSearch] = useState("");

  const [filterStatus, setFilterStatus] = useState("Status");

  const [dataMonitoringKedatanganBahan, setDataMonitoringKedatanganBahan] =
    useState();

  const [filterMonthKedatangan, setFilterMonthKedatangan] = useState(
    moment().utcOffset("+0700").month() + 1
  );

  const [filterYearKedatangan, setFilterYearKedatangan] = useState(
    moment().utcOffset("+0700").year()
  );
  const [filterJenisBarang, setJenisBarang] = useState("Pilih Jenis");

  const [popUpExportMonitoring, setPopUpExportMonitoring] = useState(false);
  const [filterDateExportFrom, setFilterDateExportFrom] = useState(today);
  const [filterDateExportUntil, setFilterDateExportUntil] = useState(today);

  const [filterDatePopUpFrom, setFilterDatePopUpFrom] = useState(today);
  const [filterDatePopUpUntil, setFilterDatePopUpUntil] = useState(today);
  const [isFilter, setIsFilter] = useState(false);

  const [popUpEdit, setPopUpEdit] = useState(false);

  const [kodeKirim, setKodeKirim] = useState();
  const [satuanBarang, setSatuanBarang] = useState("satuan");
  const [isiPerKemasan, setIsiPerKemasan] = useState();
  const [dataPickEdit, setDataPickEdit] = useState();
  const [kodeBarang, setKodeBarang] = useState();

  const [editNamaBarang, setEditNamaBarang] = useState();
  const [editStock, setEditStock] = useState();
  const [editHarga, setEditHarga] = useState();

  const [popUpNewItem, setPopUpNewItem] = useState(false);
  const [newCustomer, setNewCustomer] = useState("Pilih Customer");
  const [newMaterial, setNewMaterial] = useState();
  const [newKodeKirim, setNewKodeKirim] = useState();
  const [newKodeBarang, setNewKodeBarang] = useState();
  const [newSatuan, setNewSatuan] = useState();
  const [newIsiKemasan, setNewIsiKemasan] = useState();

  const [editRunner, setEditRunner] = useState();
  const [editBerat, setEditBerat] = useState();
  const [editLevel, setEditLevel] = useState("Level");
  const [editBahanBaku, setEditBahanBaku] = useState();
  const [editCrusher, setEditCrusher] = useState();
  const [editPewarna, setEditPewarna] = useState("Pewarna");
  const [editKomposisiMaba, setEditKomposisiMaba] = useState();
  const [editLevel1, setEditLevel1] = useState();
  const [editLevel2, setEditLevel2] = useState();
  const [editLevel3, setEditLevel3] = useState();
  const [editPendukung1, setEditPendukung1] = useState();
  const [editPendukung2, setEditPendukung2] = useState();
  const [editPendukung3, setEditPendukung3] = useState();

  const [isPinOpen, setIsPinOpen] = useState(false);
  const [isPin, setIsPin] = useState();

  // FIX: PIN di-debounce supaya tiap ketukan tidak memicu request baru.
  const [debouncedPin, setDebouncedPin] = useState(isPin);
  useEffect(() => {
    const t = setTimeout(() => setDebouncedPin(isPin), 400);
    return () => clearTimeout(t);
  }, [isPin]);

  const [popUpExportPenggunaanBahan, setPopUpExportPenggunaanBahan] =
    useState(false);
  const [typeExportPenggunaanBahan, setTypeExportPenggunaanBahan] =
    useState("");

  // ---------------------------------------------------------------
  // Kedatangan bahan
  // ---------------------------------------------------------------
  useEffect(() => {
    if (subMenu !== "MonitorKedatangan") return;

    let cancelled = false;
    postAxios(
      `${process.env.REACT_APP_ENDPOINT}/kedatanganBahan`,
      {
        tim: dataUser.tim,
        updateTime:
          filterYearKedatangan + "-" + ("0" + filterMonthKedatangan).slice(-2),
      },
      dataUser.auth,
      (res) => {
        if (!cancelled) setDataMonitoringKedatanganBahan(res);
      },
      ""
    );

    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [subMenu, filterMonthKedatangan, filterYearKedatangan]);

  // ---------------------------------------------------------------
  // Riwayat (popup search)
  // ---------------------------------------------------------------
  useEffect(() => {
    // Riwayat hanya dipakai di popup, tidak perlu fetch saat popup tertutup.
    if (!popUpSearch) return;

    let cancelled = false;
    postAxios(
      `${process.env.REACT_APP_ENDPOINT}/searchHistoryInventory`,
      {
        tim: dataUser.tim,
        dataSearch: dataPickHistory,
        company: companyPick,
        isFilter: isFilter,
        dateFrom: filterDatePopUpFrom,
        dateUntil: filterDatePopUpUntil,
        updateTime: tahunPickHistory + "-" + ("0" + bulanPickHistory).slice(-2),
      },
      dataUser.auth,
      (res) => {
        if (!cancelled) setDataHistorySearch(res);
      },
      ""
    );

    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    popUpSearch,
    dataPickHistory,
    companyPick,
    bulanPickHistory,
    tahunPickHistory,
    filterDatePopUpFrom,
    filterDatePopUpUntil,
  ]);

  useEffect(() => {
    if (hasRole(dataUser, "warehouse_gbj_admin", "sp_admin", "pr_admin")) {
      setSubMenu("barangJadi");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // ---------------------------------------------------------------
  // Inventory per company (berubah saat ganti customer)
  // ---------------------------------------------------------------
  useEffect(() => {
    if (subMenu !== "bahanBaku" && subMenu !== "barangJadi") return;

    let cancelled = false;
    postAxios(
      `${process.env.REACT_APP_ENDPOINT}/getInventory`,
      { tim: dataUser.tim, company: companyPick },
      dataUser.auth,
      (res) => {
        if (!cancelled) setDataInventory(res);
      },
      ""
    );

    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [companyPick, subMenu, refreshKey]);

  // ---------------------------------------------------------------
  // List crusher & pewarna (tidak bergantung customer, tiap satu kali)
  // ---------------------------------------------------------------
  useEffect(() => {
    if (subMenu !== "bahanBaku" && subMenu !== "barangJadi") return;

    let cancelled = false;
    postAxios(
      `${process.env.REACT_APP_ENDPOINT}/getListCrusher`,
      { tim: dataUser.tim },
      dataUser.auth,
      (res) => {
        if (!cancelled) setDataListCrusher(res);
      },
      ""
    );
    postAxios(
      `${process.env.REACT_APP_ENDPOINT}/getListPewarna`,
      { tim: dataUser.tim },
      dataUser.auth,
      (res) => {
        if (!cancelled) setDataListPewarna(res);
      },
      ""
    );

    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [subMenu, refreshKey]);

  // ---------------------------------------------------------------
  // List barang jadi (semua company; difilter di frontend lewat companyPick)
  // ---------------------------------------------------------------
  useEffect(() => {
    if (subMenu !== "bahanBaku" && subMenu !== "barangJadi") return;

    let cancelled = false;
    postAxios(
      `${process.env.REACT_APP_ENDPOINT}/getListBarangJadi`,
      {
        tim: dataUser.tim,
        type: debouncedPin === "1020" ? "listHarga" : "listBarangJadi",
      },
      dataUser.auth,
      (res) => {
        if (!cancelled) setDataBarangJadi(res);
      },
      ""
    );

    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [subMenu, refreshKey, debouncedPin]);

  // Pastikan hasil dari API selalu berupa array sebelum dipakai
  const safeDataBarangJadi = Array.isArray(dataBarangJadi)
    ? dataBarangJadi
    : [];

  const searchBarangJadi = safeDataBarangJadi.find(
    (e) => e.company == companyPick
  );

  const handleExportBarangJadi = () => {
    const filteredDataExcel = (searchBarangJadi?.data || []).map(
      (obj, index) => {
        return {
          No: index + 1,
          "NAMA PRODUK": obj.material,
          "JUMLAH (PCS)": obj.weight,
        };
      }
    );

    const workSheet = XLSX.utils.json_to_sheet(filteredDataExcel);

    workSheet["!cols"] = [{ wch: 4 }, { wch: 50 }, { wch: 15 }];
    const workBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workBook, workSheet, "Barang Jadi");
    XLSX.write(workBook, { bookType: "xlsx", type: "buffer" });
    XLSX.write(workBook, { bookType: "xlsx", type: "binary" });
    XLSX.writeFile(
      workBook,
      `Laporan Barang Jadi PT.${companyPick} ${
        moment().utcOffset("+0700").month() + 1
      }-${moment().utcOffset("+0700").year()}.xlsx`
    );
  };

  const dataPick = () => {
    let data;
    Array.isArray(dataInventory) &&
      dataInventory.forEach((element) => {
        if (element.company === companyPick) {
          data = element;
        }
      });
    return data;
  };
  const Material = dataPick();

  const dataPickCrusher = () => {
    let data;
    Array.isArray(dataListCrusher) &&
      dataListCrusher.forEach((element) => {
        if (element.company === companyPick) {
          data = element;
        }
      });
    return data;
  };

  const Crusher = dataPickCrusher();

  const dataPickPewarna = () => {
    let data;
    Array.isArray(dataListPewarna) &&
      dataListPewarna.forEach((element) => {
        if (element.company === companyPick) {
          data = element;
        }
      });
    return data;
  };
  const Pewarna = dataPickPewarna();

  const searchFeature = (params) => {
    const list = (searchBarangJadi?.data || []).filter(
      (item) => !item.company || item.company === companyPick
    );
    if (paramSearch === "material" && valueSearch !== "") {
      return list.filter((value) =>
        (value.material || "").toLowerCase().includes(params.toLowerCase())
      );
    }
    return list;
  };
  let dataTemp = searchFeature(valueSearch);

  const handlePick = (data) => {
    setPopUpSearch(true);
    setDataPickHistory(data);
  };

  const filterStatusSearch = (params) => {
    const list = Array.isArray(dataHistorySearch) ? dataHistorySearch : [];
    if (filterStatus !== "Status") {
      return list.filter((value) =>
        (value.statusBahan || "").toLowerCase().includes(params.toLowerCase())
      );
    }
    return list;
  };
  let dataFilterStatus = filterStatusSearch(filterStatus);

  const validateCustomer = () => {
    let data = [];
    Array.isArray(dataMonitoringKedatanganBahan) &&
      dataMonitoringKedatanganBahan.forEach((obj) => {
        if (obj.company === companyPick) {
          let findIfNameExist = data.findIndex(function (item) {
            return item.material === obj.material;
          });
          if (findIfNameExist === -1) {
            data.push({
              company: obj.company,
              kedatangan: obj.kedatangan,
              material: obj.material,
              month: obj.month,
              statusBahan: obj.statusBahan,
              tim: obj.tim,
              type: obj.type,
              weightBefore: obj.weightBefore,
              data: [
                {
                  dataWeight: obj.dataWeight,
                  keterangan: obj.keterangan,
                  updatedBy: obj.updatedBy,
                  tanggal: moment(obj.updateTime)
                    .utcOffset("+0700")
                    .format("DD"),
                  date: moment(obj.updateTime)
                    .utcOffset("+0700")
                    .format("YYYY-MM-DD"),
                },
              ],
            });
          } else {
            data[findIfNameExist].data.push({
              dataWeight: obj.dataWeight,
              keterangan: obj.keterangan,
              updatedBy: obj.updatedBy,
              tanggal: moment(obj.updateTime).utcOffset("+0700").format("DD"),
              date: moment(obj.updateTime)
                .utcOffset("+0700")
                .format("YYYY-MM-DD"),
            });
          }
        }
      });
    return data;
  };

  const dataMonitoringKedatanganBahanTemp = validateCustomer();

  const filterJenis = (params) => {
    if (filterJenisBarang !== "Pilih Jenis") {
      return dataMonitoringKedatanganBahanTemp.filter((value) =>
        (value.type || "").toLowerCase().includes(params.toLowerCase())
      );
    }
    return dataMonitoringKedatanganBahanTemp;
  };
  let dataJenisBarang = filterJenis(filterJenisBarang);

  const handleFilterFrom = (e) => {
    setFilterDatePopUpFrom(e.target.value);
    setIsFilter(true);
  };

  const handleFilterUntil = (e) => {
    setFilterDatePopUpUntil(e.target.value);
    setIsFilter(true);
  };

  const foundObject = safeDataBarangJadi.find(
    (obj) => obj.company === companyPick
  );

  const handlePickEdit = (data) => {
    if (data) {
      setDataPickEdit(data);
      setIsiPerKemasan(data.isiKemasan);
      setKodeKirim(data.kodeKirim);
      setKodeBarang(data.kodeBarang);
      setSatuanBarang(data.satuan);
      setEditNamaBarang(data.material);

      setEditRunner(data.runner);
      setEditBerat(data.berat);
      setEditLevel(data.level);
      setEditPewarna({ label: data.pewarna, value: data.pewarna });
      setEditKomposisiMaba(data.komposisiMaba);
      setEditBahanBaku({ label: data.bahanBaku, value: data.bahanBaku });
      setEditCrusher({ label: data.crusher, value: data.crusher });

      setEditLevel1({
        value: data.level1,
        label: data.level1,
      });
      setEditLevel2({
        value: data.level2,
        label: data.level2,
      });
      setEditLevel3({
        value: data.level3,
        label: data.level3,
      });

      setEditPendukung1({ label: data.pendukung1, value: data.pendukung1 });
      setEditPendukung2({ label: data.pendukung2, value: data.pendukung2 });
      setEditPendukung3({ label: data.pendukung3, value: data.pendukung3 });

      setEditStock(data.weight);
      setEditHarga(data.harga);
      setPopUpEdit(true);
    }
  };

  const handleKirimEditBarangJadi = () => {
    setPopUpEdit(false);

    const findByKode = (selected) =>
      foundObject?.data?.find((obj) =>
        selected ? obj.kodeBarang === selected.value : false
      );

    const foundDataLevel1 = findByKode(editLevel1);
    const foundDataLevel2 = findByKode(editLevel2);
    const foundDataLevel3 = findByKode(editLevel3);
    const foundPendukung1 = findByKode(editPendukung1);
    const foundPendukung2 = findByKode(editPendukung2);
    const foundPendukung3 = findByKode(editPendukung3);

    // FIX: refresh dipicu SETELAH POST selesai (kalau postAxios mengembalikan
    // promise). Kalau tidak, Promise.resolve membuatnya langsung jalan seperti
    // sebelumnya.
    Promise.resolve(
      postAxios(
        `${process.env.REACT_APP_ENDPOINT}/editBarangJadi`,
        {
          tim: dataUser.tim,
          company: companyPick,
          material: dataPickEdit.material,
          jenis: dataPickEdit.jenis,
          kodeKirim: kodeKirim,
          kodeBarang: kodeBarang,
          satuan: satuanBarang,
          isiKemasan: isiPerKemasan,
          editNamaBarang: editNamaBarang,
          editStock: Number(editStock),
          editHarga: Number(editHarga),

          editRunner: editRunner,
          editBerat: editBerat,
          editLevel: editLevel,
          editBahanBaku: editBahanBaku ? editBahanBaku.value : null,
          editCrusher: editCrusher ? editCrusher.value : null,
          editPewarna: editPewarna ? editPewarna.value : null,
          editKomposisiMaba: editKomposisiMaba ? editKomposisiMaba : null,
          editLevel1: foundDataLevel1 ? foundDataLevel1.kodeBarang : null,
          editLevel2: foundDataLevel2 ? foundDataLevel2.kodeBarang : null,
          editLevel3: foundDataLevel3 ? foundDataLevel3.kodeBarang : null,
          editPendukung1: foundPendukung1 ? foundPendukung1.kodeBarang : null,
          editPendukung2: foundPendukung2 ? foundPendukung2.kodeBarang : null,
          editPendukung3: foundPendukung3 ? foundPendukung3.kodeBarang : null,
        },
        dataUser.auth,
        "",
        ""
      )
    ).finally(triggerRefresh);

    setKodeKirim();
    setEditLevel1();
    setEditLevel2();
    setEditLevel3();
    setEditPendukung1();
    setEditPendukung2();
    setEditPendukung3();
    setDataPickEdit();
    setSatuanBarang();
    setIsiPerKemasan();
  };

  let dateTempListTanggal = [];

  var days = moment(
    `${filterYearKedatangan}-${("0" + filterMonthKedatangan).slice(-2)}`
  ).daysInMonth();

  for (let index = 0; index < days; index++) {
    dateTempListTanggal.push({
      date: `${filterYearKedatangan}-${("0" + filterMonthKedatangan).slice(
        -2
      )}-${("0" + (index + 1)).slice(-2)}`,
      tanggal: `${("0" + (index + 1)).slice(-2)}`,
    });
  }

  const handleCloseAddNewItem = () => {
    setNewIsiKemasan();
    setNewSatuan();
    setNewKodeBarang();
    setNewKodeKirim();
    setNewMaterial();
    setPopUpNewItem(false);
    setNewCustomer("Pilih Customer");
  };

  const handleAddNewItem = () => {
    if (newCustomer !== "Pilih Customer" && newMaterial) {
      // FIX: refresh setelah POST selesai (lihat catatan di handleKirimEditBarangJadi)
      Promise.resolve(
        postAxios(
          `${process.env.REACT_APP_ENDPOINT}/addNewListBarangJadi`,
          {
            tim: dataUser.tim,
            company: newCustomer,
            material: newMaterial,
            kodeBarang: newKodeBarang,
            kodeKirim: newKodeKirim,
            satuan: newSatuan,
            isiKemasan: newIsiKemasan,
          },
          dataUser.auth,
          "",
          ""
        )
      ).finally(triggerRefresh);
      handleCloseAddNewItem();
    }
  };

  let dataRestructure = [];

  foundObject?.data?.forEach((element) => {
    if (element.kodeBarang) {
      dataRestructure.push({
        value: element.kodeBarang,
        label: `${element.kodeBarang}-${element.kodeKirim}`,
      });
    }
  });

  let dataRestructureMurni = [];
  let dataRestructureCrusher = [];

  foundObject?.bahan?.forEach((element) => {
    if (element.kodeBarang && element.type === "MURNI") {
      dataRestructureMurni.push({
        value: element.kodeBarang,
        label: `${element.kodeBarang}-${element.kodeKirim}`,
      });
    } else if (element.kodeBarang && element.type === "CRUSHER") {
      dataRestructureCrusher.push({
        value: element.kodeBarang,
        label: `${element.kodeBarang}-${element.kodeKirim}`,
      });
    }
  });

  const optionListCrusher = [];

  const searchCrusher = Array.isArray(dataListCrusher)
    ? dataListCrusher.find((e) => e.company == companyPick)
    : undefined;

  searchCrusher?.data?.forEach((element) => {
    optionListCrusher.push({
      label: element.material,
      value: element.material,
    });
  });

  const optionListPewarna = [];

  const searchPewarna = Array.isArray(dataListPewarna)
    ? dataListPewarna.find((e) => e.company == companyPick)
    : undefined;

  searchPewarna?.data?.forEach((element) => {
    optionListPewarna.push({
      label: element.material,
      value: element.material,
    });
  });

  // Pakai Material (sesuai companyPick), fallback ke index 0, lalu [].
  const optionListBahanBaku = [];

  (Material?.bahanBaku || dataInventory?.[0]?.bahanBaku || []).forEach(
    (element) => {
      optionListBahanBaku.push({
        label: element.material,
        value: element.material,
      });
    }
  );

  const handleExportLaporanFg = async () => {
    const { data } = await axios.post(
      `${process.env.REACT_APP_ENDPOINT}/exportLaporanPenggunaanBahan`,
      {
        tim: dataUser.tim,
        filterFrom: filterDatePopUpFrom,
        filterUntil: filterDatePopUpUntil,
        company: companyPick,
        type: typeExportPenggunaanBahan,
      },
      {
        headers: {
          Authorization: `Bearer ${dataUser.auth}`,
        },
      }
    );

    if (data.code === 200) {
      const dataBalikan = data?.data || [];

      const filteredDataExcel =
        dataBalikan &&
        dataBalikan.map((obj) => {
          const checkOk = obj?.dataWeight || 0;
          const checkBerat = obj?.berat || 0;
          const checkKomposisiMaba = obj?.komposisiMaba || 0;

          let calculateFgKg = (checkOk * checkBerat) / 1000;

          let calculateKomposisiPewarna =
            calculateFgKg * (checkKomposisiMaba / 100);

          return {
            item_number: obj.material,
            "hasil_fg_ok (Pcs)": checkOk,
            "Berat Produk": switchDotsAndCommas(numberWithCommas(checkBerat)),
            "hasil_fg_ok (Kg)": switchDotsAndCommas(
              numberWithCommas(calculateFgKg.toFixed(3))
            ),
            date: moment(obj.updateTime)
              .utcOffset("+0700")
              .format("DD-MM-YYYY"),
            "status Bahan": obj.statusBahan,
            "Bahan Baku": obj.kodeMurni || "",
            Pewarna: obj.pewarna || "",
            "% Komposisi": checkKomposisiMaba
              ? `${switchDotsAndCommas(numberWithCommas(checkKomposisiMaba))}`
              : "",
            "Komposisi Pewarna": switchDotsAndCommas(
              numberWithCommas(calculateKomposisiPewarna.toFixed(3))
            ),
          };
        });

      // ==== Summary per Bahan Baku (berdasarkan Kg) ====
      const mapSumBahanBaku = new Map();

      dataBalikan.forEach((obj) => {
        const checkOk = obj?.dataWeight || 0;
        const checkBerat = obj?.berat || 0;
        const calculateFgKg = (checkOk * checkBerat) / 1000;

        const key = obj.kodeMurni || "(Kosong)";
        const currentSum = mapSumBahanBaku.get(key) || 0;
        mapSumBahanBaku.set(key, currentSum + calculateFgKg);
      });

      const summaryBahanBaku = Array.from(
        mapSumBahanBaku,
        ([bahanBaku, total]) => ({
          item_number: bahanBaku,
          totalKg: total,
        })
      );

      // ==== Summary Komposisi Pewarna (berdasarkan Kg) ====
      const mapSumPewarna = new Map();

      dataBalikan.forEach((obj) => {
        const checkOk = obj?.dataWeight || 0;
        const checkBerat = obj?.berat || 0;
        const checkKomposisiMaba = obj?.komposisiMaba || 0;

        const calculateFgKg = (checkOk * checkBerat) / 1000;
        const calculateKomposisiPewarna =
          calculateFgKg * (checkKomposisiMaba / 100);

        const key = obj.pewarna || "(Kosong)";
        const currentSum = mapSumPewarna.get(key) || 0;
        mapSumPewarna.set(key, currentSum + calculateKomposisiPewarna);
      });

      const summaryPewarna = Array.from(mapSumPewarna, ([pewarna, total]) => ({
        pewarna,
        total,
      }));

      // ==== Gabungkan kedua summary jadi sejajar (side by side) ====
      const maxLength = Math.max(
        summaryBahanBaku.length,
        summaryPewarna.length
      );

      const summaryGabungan = Array.from({ length: maxLength }, (_, i) => {
        const bahanBaku = summaryBahanBaku[i];
        const pewarna = summaryPewarna[i];

        return {
          item_number: bahanBaku ? bahanBaku.item_number : "",
          "hasil_fg_ok (Pcs)": "",
          "Berat Produk": "",
          "hasil_fg_ok (Kg)": bahanBaku
            ? switchDotsAndCommas(
                numberWithCommas(bahanBaku.totalKg.toFixed(3))
              )
            : "",
          date: "",
          "status Bahan": "",
          "Bahan Baku": "",
          Pewarna: "",
          "% Komposisi": "",
          "Komposisi Pewarna": "",
          " ": "",
          "Ringkasan Pewarna": pewarna ? pewarna.pewarna : "",
          "Total Komposisi Pewarna": pewarna
            ? switchDotsAndCommas(numberWithCommas(pewarna.total.toFixed(3)))
            : "",
        };
      });

      const emptyRow = {
        item_number: "",
        "hasil_fg_ok (Pcs)": "",
        "Berat Produk": "",
        "hasil_fg_ok (Kg)": "",
        date: "",
        "status Bahan": "",
        "Bahan Baku": "",
        Pewarna: "",
        "% Komposisi": "",
        "Komposisi Pewarna": "",
        " ": "",
        "Ringkasan Pewarna": "",
        "Total Komposisi Pewarna": "",
      };

      const finalDataExcel = [
        ...filteredDataExcel,
        emptyRow,
        ...summaryGabungan,
      ];

      const workSheet = XLSX.utils.json_to_sheet(finalDataExcel);
      workSheet["!cols"] = [
        { wch: 49 }, // item_number
        { wch: 15 }, // hasil_fg_ok (Pcs)
        { wch: 13 }, // Berat Produk
        { wch: 15 }, // hasil_fg_ok (Kg)
        { wch: 10 }, // date
        { wch: 11 }, // status Bahan
        { wch: 21 }, // Bahan Baku
        { wch: 25 }, // Pewarna
        { wch: 12 }, // % Komposisi
        { wch: 16 }, // Komposisi Pewarna
        { wch: 2 }, // spacer
        { wch: 25 }, // Ringkasan Pewarna
        { wch: 18 }, // Total Komposisi Pewarna
      ];

      const highlightCols = [9, 12]; // "Komposisi Pewarna" & "Total Komposisi Pewarna"
      const range = XLSX.utils.decode_range(workSheet["!ref"]);

      for (let row = range.s.r; row <= range.e.r; row++) {
        highlightCols.forEach((colIndex) => {
          const cellAddress = XLSX.utils.encode_cell({ r: row, c: colIndex });
          const cell = workSheet[cellAddress];
          if (!cell) return;

          cell.s = {
            fill: {
              fgColor: { rgb: "FFFF00" },
            },
            font: {
              bold: row === 0,
            },
            alignment: {
              horizontal: "left",
            },
          };
        });
      }

      const workBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workBook, workSheet, "Sheet1");
      XLSX.writeFile(
        workBook,
        `FG PT.${companyPick} ${moment(filterDatePopUpFrom)
          .utcOffset("+0700")
          .format("DD-MM-YYYY")} - ${moment(filterDatePopUpUntil)
          .utcOffset("+0700")
          .format("DD-MM-YYYY")}.xlsx`
      );
    }
  };

  const handleExportLaporanRunner = async () => {
    const { data } = await axios.post(
      `${process.env.REACT_APP_ENDPOINT}/exportLaporanPenggunaanBahan`,
      {
        tim: dataUser.tim,
        filterFrom: filterDatePopUpFrom,
        filterUntil: filterDatePopUpUntil,
        company: companyPick,
        type: typeExportPenggunaanBahan,
      },
      {
        headers: {
          Authorization: `Bearer ${dataUser.auth}`,
        },
      }
    );

    if (data.code === 200) {
      const dataBalikan = data?.data || [];

      const filteredDataExcel =
        dataBalikan &&
        dataBalikan.map((obj) => {
          const checkRunner = obj?.runner || 0;
          const checkOk = obj?.dataWeight || 0;
          const checkKomposisiMaba = obj?.komposisiMaba || 0;

          let calculateRunner = (checkOk * checkRunner) / 1000;

          let calculateKomposisiPewarna =
            calculateRunner * (checkKomposisiMaba / 100);

          return {
            item_number: obj.material,
            hasil_runner_fg: switchDotsAndCommas(
              numberWithCommas(calculateRunner.toFixed(3))
            ),
            "Berat Runner": switchDotsAndCommas(numberWithCommas(checkRunner)),
            "OK (Pcs)": checkOk,
            date: moment(obj.updateTime)
              .utcOffset("+0700")
              .format("DD-MM-YYYY"),
            "status Bahan": obj.statusBahan,
            "Bahan Baku": obj.kodeMurni,
            Pewarna: obj.pewarna || "",
            "% Komposisi": checkKomposisiMaba
              ? `${switchDotsAndCommas(numberWithCommas(checkKomposisiMaba))}`
              : "",
            "Komposisi Pewarna": switchDotsAndCommas(
              numberWithCommas(calculateKomposisiPewarna.toFixed(3))
            ),
          };
        });

      // ==== Summary per Bahan Baku (kodeMurni) ====
      const mapSumKodeMurni = new Map();

      dataBalikan.forEach((obj) => {
        const checkRunner = obj?.runner || 0;
        const checkOk = obj?.dataWeight || 0;
        const calculateRunner = (checkOk * checkRunner) / 1000;

        const key = obj.kodeMurni || "(Kosong)";
        const currentSum = mapSumKodeMurni.get(key) || 0;
        mapSumKodeMurni.set(key, currentSum + calculateRunner);
      });

      const summaryKodeMurni = Array.from(
        mapSumKodeMurni,
        ([kodeMurni, total]) => ({
          item_number: kodeMurni,
          hasil_runner_fg: switchDotsAndCommas(
            numberWithCommas(total.toFixed(3))
          ),
        })
      );

      // ==== Summary Komposisi Pewarna ====
      const mapSumPewarna = new Map();

      dataBalikan.forEach((obj) => {
        const checkRunner = obj?.runner || 0;
        const checkOk = obj?.dataWeight || 0;
        const checkKomposisiMaba = obj?.komposisiMaba || 0;

        const calculateRunner = (checkOk * checkRunner) / 1000;
        const calculateKomposisiPewarna =
          calculateRunner * (checkKomposisiMaba / 100);

        const key = obj.pewarna || "(Kosong)";
        const currentSum = mapSumPewarna.get(key) || 0;
        mapSumPewarna.set(key, currentSum + calculateKomposisiPewarna);
      });

      const summaryPewarna = Array.from(mapSumPewarna, ([pewarna, total]) => ({
        pewarna,
        total,
      }));

      // ==== Gabungkan kedua summary jadi sejajar (side by side) ====
      const maxLength = Math.max(
        summaryKodeMurni.length,
        summaryPewarna.length
      );

      const summaryGabungan = Array.from({ length: maxLength }, (_, i) => {
        const bahanBaku = summaryKodeMurni[i];
        const pewarna = summaryPewarna[i];

        return {
          item_number: bahanBaku ? bahanBaku.item_number : "",
          hasil_runner_fg: bahanBaku ? bahanBaku.hasil_runner_fg : "",
          "Berat Runner": "",
          "OK (Pcs)": "",
          date: "",
          "status Bahan": "",
          "Bahan Baku": "",
          Pewarna: "",
          "% Komposisi": "",
          "Komposisi Pewarna": "",
          " ": "",
          "Ringkasan Pewarna": pewarna ? pewarna.pewarna : "",
          "Total Komposisi Pewarna": pewarna
            ? switchDotsAndCommas(numberWithCommas(pewarna.total.toFixed(3)))
            : "",
        };
      });

      const emptyRow = {
        item_number: "",
        hasil_runner_fg: "",
        "Berat Runner": "",
        "OK (Pcs)": "",
        date: "",
        "status Bahan": "",
        "Bahan Baku": "",
        Pewarna: "",
        "% Komposisi": "",
        "Komposisi Pewarna": "",
        " ": "",
        "Ringkasan Pewarna": "",
        "Total Komposisi Pewarna": "",
      };

      const finalDataExcel = [
        ...filteredDataExcel,
        emptyRow,
        ...summaryGabungan,
      ];

      const workSheet = XLSX.utils.json_to_sheet(finalDataExcel);
      workSheet["!cols"] = [
        { wch: 49 }, // item_number
        { wch: 14 }, // hasil_runner_fg
        { wch: 13 }, // Berat Runner
        { wch: 11 }, // OK (Pcs)
        { wch: 10 }, // date
        { wch: 11 }, // status Bahan
        { wch: 21 }, // Bahan Baku
        { wch: 25 }, // Pewarna
        { wch: 12 }, // % Komposisi
        { wch: 16 }, // Komposisi Pewarna
        { wch: 2 }, // spacer
        { wch: 25 }, // Ringkasan Pewarna
        { wch: 18 }, // Total Komposisi Pewarna
      ];

      const highlightCols = [9, 12]; // "Komposisi Pewarna", "Total Komposisi Pewarna"
      const range = XLSX.utils.decode_range(workSheet["!ref"]);

      for (let row = range.s.r; row <= range.e.r; row++) {
        highlightCols.forEach((colIndex) => {
          const cellAddress = XLSX.utils.encode_cell({ r: row, c: colIndex });
          const cell = workSheet[cellAddress];
          if (!cell) return;

          cell.s = {
            fill: {
              fgColor: { rgb: "FFFF00" },
            },
            font: {
              bold: row === 0,
            },
            alignment: {
              horizontal: "left",
            },
          };
        });
      }

      const workBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workBook, workSheet, "Sheet1");
      XLSX.writeFile(
        workBook,
        `Runner PT.${companyPick} ${moment(filterDatePopUpFrom)
          .utcOffset("+0700")
          .format("DD-MM-YYYY")} - ${moment(filterDatePopUpUntil)
          .utcOffset("+0700")
          .format("DD-MM-YYYY")}.xlsx`
      );
    }
  };

  const handleExportLaporanNgProduk = async () => {
    const { data } = await axios.post(
      `${process.env.REACT_APP_ENDPOINT}/exportLaporanPenggunaanBahan`,
      {
        tim: dataUser.tim,
        filterFrom: filterDatePopUpFrom,
        filterUntil: filterDatePopUpUntil,
        company: companyPick,
        type: typeExportPenggunaanBahan,
      },
      {
        headers: {
          Authorization: `Bearer ${dataUser.auth}`,
        },
      }
    );

    if (data.code === 200) {
      const dataBalikan = data?.data || [];

      const filteredDataExcel =
        dataBalikan &&
        dataBalikan.map((obj) => {
          const checkNg = obj?.dataReject || 0;
          const checkBerat = obj?.berat || 0;
          const checkKomposisiMaba = obj?.komposisiMaba || 0;

          let calculateNgProduk = (checkNg * checkBerat) / 1000;

          let calculateKomposisiPewarna =
            calculateNgProduk * (checkKomposisiMaba / 100);

          return {
            item_number: obj.material,
            hasil_material_ng: switchDotsAndCommas(
              numberWithCommas(calculateNgProduk.toFixed(3))
            ),
            "Berat Produk": switchDotsAndCommas(numberWithCommas(checkBerat)),
            "NG (Pcs)": checkNg,
            date: moment(obj.updateTime)
              .utcOffset("+0700")
              .format("DD-MM-YYYY"),
            "status Bahan": obj.statusBahan,
            "Bahan Baku": obj.kodeMurni,
            Pewarna: obj.pewarna || "",
            "% Komposisi": checkKomposisiMaba
              ? `${switchDotsAndCommas(numberWithCommas(checkKomposisiMaba))}`
              : "",
            "Komposisi Pewarna": switchDotsAndCommas(
              numberWithCommas(calculateKomposisiPewarna.toFixed(3))
            ),
          };
        });

      // ==== Summary per Bahan Baku (kodeMurni) ====
      const mapSumKodeMurni = new Map();

      dataBalikan.forEach((obj) => {
        const checkNg = obj?.dataReject || 0;
        const checkBerat = obj?.berat || 0;

        let calculateNgProduk = (checkNg * checkBerat) / 1000;

        const key = obj.kodeMurni || "(Kosong)";
        const currentSum = mapSumKodeMurni.get(key) || 0;
        mapSumKodeMurni.set(key, currentSum + calculateNgProduk);
      });

      const summaryKodeMurni = Array.from(
        mapSumKodeMurni,
        ([kodeMurni, total]) => ({
          item_number: kodeMurni,
          hasil_material_ng: switchDotsAndCommas(
            numberWithCommas(total.toFixed(3))
          ),
        })
      );

      // ==== Summary Komposisi Pewarna ====
      const mapSumPewarna = new Map();

      dataBalikan.forEach((obj) => {
        const checkNg = obj?.dataReject || 0;
        const checkBerat = obj?.berat || 0;
        const checkKomposisiMaba = obj?.komposisiMaba || 0;

        const calculateNgProduk = (checkNg * checkBerat) / 1000;
        const calculateKomposisiPewarna =
          calculateNgProduk * (checkKomposisiMaba / 100);

        const key = obj.pewarna || "(Kosong)";
        const currentSum = mapSumPewarna.get(key) || 0;
        mapSumPewarna.set(key, currentSum + calculateKomposisiPewarna);
      });

      const summaryPewarna = Array.from(mapSumPewarna, ([pewarna, total]) => ({
        pewarna,
        total,
      }));

      // ==== Gabungkan kedua summary jadi sejajar (side by side) ====
      const maxLength = Math.max(
        summaryKodeMurni.length,
        summaryPewarna.length
      );

      const summaryGabungan = Array.from({ length: maxLength }, (_, i) => {
        const bahanBaku = summaryKodeMurni[i];
        const pewarna = summaryPewarna[i];

        return {
          item_number: bahanBaku ? bahanBaku.item_number : "",
          hasil_material_ng: bahanBaku ? bahanBaku.hasil_material_ng : "",
          "Berat Produk": "",
          "NG (Pcs)": "",
          date: "",
          "status Bahan": "",
          "Bahan Baku": "",
          Pewarna: "",
          "% Komposisi": "",
          "Komposisi Pewarna": "",
          " ": "",
          "Ringkasan Pewarna": pewarna ? pewarna.pewarna : "",
          "Total Komposisi Pewarna": pewarna
            ? switchDotsAndCommas(numberWithCommas(pewarna.total.toFixed(3)))
            : "",
        };
      });

      const emptyRow = {
        item_number: "",
        hasil_material_ng: "",
        "Berat Produk": "",
        "NG (Pcs)": "",
        date: "",
        "status Bahan": "",
        "Bahan Baku": "",
        Pewarna: "",
        "% Komposisi": "",
        "Komposisi Pewarna": "",
        " ": "",
        "Ringkasan Pewarna": "",
        "Total Komposisi Pewarna": "",
      };

      const finalDataExcel = [
        ...filteredDataExcel,
        emptyRow,
        ...summaryGabungan,
      ];

      const workSheet = XLSX.utils.json_to_sheet(finalDataExcel);
      workSheet["!cols"] = [
        { wch: 49 }, // item_number
        { wch: 14 }, // hasil_material_ng
        { wch: 13 }, // Berat Produk
        { wch: 11 }, // NG (Pcs)
        { wch: 10 }, // date
        { wch: 11 }, // status Bahan
        { wch: 21 }, // Bahan Baku
        { wch: 25 }, // Pewarna
        { wch: 12 }, // % Komposisi
        { wch: 16 }, // Komposisi Pewarna
        { wch: 2 }, // spacer
        { wch: 25 }, // Ringkasan Pewarna
        { wch: 18 }, // Total Komposisi Pewarna
      ];

      const highlightCols = [9, 12]; // "Komposisi Pewarna", "Total Komposisi Pewarna"
      const range = XLSX.utils.decode_range(workSheet["!ref"]);

      for (let row = range.s.r; row <= range.e.r; row++) {
        highlightCols.forEach((colIndex) => {
          const cellAddress = XLSX.utils.encode_cell({ r: row, c: colIndex });
          const cell = workSheet[cellAddress];
          if (!cell) return;

          cell.s = {
            fill: {
              fgColor: { rgb: "FFFF00" },
            },
            font: {
              bold: row === 0,
            },
            alignment: {
              horizontal: "left",
            },
          };
        });
      }

      const workBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workBook, workSheet, "Sheet1");
      XLSX.writeFile(
        workBook,
        `NG PT.${companyPick} ${moment(filterDatePopUpFrom)
          .utcOffset("+0700")
          .format("DD-MM-YYYY")} - ${moment(filterDatePopUpUntil)
          .utcOffset("+0700")
          .format("DD-MM-YYYY")}.xlsx`
      );
    }
  };

  const handleExportInventory = async () => {
    if (dataFilterStatus && dataFilterStatus.length > 0) {
      const dataBalikan = dataFilterStatus || [];

      const filteredDataExcel =
        dataBalikan &&
        dataBalikan.map((obj, index) => {
          let dataRejectTemp = obj?.dataReject || 0;

          const calculateWeightDisplay = () => {
            if (!obj)
              return formatDot(switchDotsAndCommas(numberWithCommas(0)));

            const { statusBahan, status, weightBefore, dataWeight } = obj;

            let result;

            if (statusBahan === "Datang") {
              result = weightBefore + dataWeight;
            } else if (statusBahan === "Kiriman") {
              result = weightBefore - dataWeight;
            } else if (statusBahan === "Produksi" && !status) {
              result = weightBefore + dataWeight;
            } else if (statusBahan === "Keluar") {
              result = weightBefore - dataWeight;
            } else if (status === "Keluar") {
              result = weightBefore - dataWeight - dataRejectTemp;
            } else {
              result = weightBefore + dataWeight - dataRejectTemp;
            }

            return formatDot(switchDotsAndCommas(numberWithCommas(result)));
          };
          return {
            "No.": `${index + 1}.`,
            Tanggal: moment(obj.updateTime).utcOffset(7).format("DD-MM-YYYY"),
            Material: obj.material,
            Cust: obj.company,
            Jumlah: obj.dataWeight,
            Status: (obj?.statusBahan || "").toUpperCase(),
            Sisa: calculateWeightDisplay(),
            Operator: (obj?.updatedBy || "").split(" ")[0],
            Keterangan: obj.keterangan,
          };
        });

      const workSheet = XLSX.utils.json_to_sheet(filteredDataExcel);
      workSheet["!cols"] = [
        { wch: 4 },
        { wch: 10 },
        { wch: 24 },
        { wch: 6 },
        { wch: 8 },
        { wch: 8 },
        { wch: 10 },
        { wch: 10 },
        { wch: 35 },
      ];
      const workBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workBook, workSheet, "Sheet1");
      XLSX.write(workBook, { bookType: "xlsx", type: "buffer" });
      XLSX.write(workBook, { bookType: "xlsx", type: "binary" });
      XLSX.writeFile(
        workBook,
        `Riwayat keluar masuk ${
          dataPickHistory?.material || ""
        } PT.${companyPick} - ${("0" + bulanPickHistory).slice(
          -2
        )} ${tahunPickHistory}.xlsx`
      );
    }
  };

  const handleExportBahanBaku = () => {
    const mergeArray = [
      ...(Pewarna?.data || []),
      ...(Material?.bahanBaku || []),
    ];

    const filteredDataExcel = mergeArray.map((obj, index) => {
      return {
        No: index + 1,
        "NAMA MATERIAL": obj.material,
        "JUMLAH (PCS)": obj.weight,
      };
    });

    const workSheet = XLSX.utils.json_to_sheet(filteredDataExcel);

    workSheet["!cols"] = [{ wch: 4 }, { wch: 50 }, { wch: 15 }];
    const workBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workBook, workSheet, "Bahan Baku");
    XLSX.write(workBook, { bookType: "xlsx", type: "buffer" });
    XLSX.write(workBook, { bookType: "xlsx", type: "binary" });
    XLSX.writeFile(
      workBook,
      `Laporan Bahan Baku PT.${companyPick} ${
        moment().utcOffset("+0700").month() + 1
      }-${moment().utcOffset("+0700").year()}.xlsx`
    );
  };

  return {
    Material,
    setCompanyPick,
    companyPick,
    subMenu,
    setSubMenu,
    dataUser,
    Crusher,
    popUpSearch,
    setPopUpSearch,
    setDataPickHistory,
    tahunPickHistory,
    setTahunPickHistory,
    bulanPickHistory,
    setBulanPickHistory,
    Pewarna,
    setValueSearch,
    dataTemp,
    handlePick,
    valueSearch,
    handleExportBarangJadi,
    setFilterStatus,
    filterStatus,
    dataFilterStatus,
    dataMonitoringKedatanganBahanTemp,
    filterMonthKedatangan,
    setFilterMonthKedatangan,
    filterYearKedatangan,
    setFilterYearKedatangan,
    filterJenisBarang,
    setJenisBarang,
    dataJenisBarang,
    popUpExportMonitoring,
    setPopUpExportMonitoring,
    filterDateExportFrom,
    setFilterDateExportFrom,
    filterDateExportUntil,
    setFilterDateExportUntil,
    handleFilterFrom,
    filterDatePopUpUntil,
    setFilterDatePopUpUntil,
    filterDatePopUpFrom,
    setIsFilter,
    today,
    setFilterDatePopUpFrom,
    handleFilterUntil,
    popUpEdit,
    handleKirimEditBarangJadi,
    kodeKirim,
    setKodeKirim,
    satuanBarang,
    setSatuanBarang,
    isiPerKemasan,
    setIsiPerKemasan,
    handlePickEdit,
    dataPickEdit,
    setPopUpEdit,
    setKodeBarang,
    kodeBarang,
    dateTempListTanggal,
    editNamaBarang,
    setEditNamaBarang,
    editStock,
    setEditStock,
    popUpNewItem,
    setPopUpNewItem,
    newMaterial,
    setNewMaterial,
    newKodeKirim,
    setNewKodeKirim,
    newKodeBarang,
    setNewKodeBarang,
    newSatuan,
    setNewSatuan,
    newIsiKemasan,
    setNewIsiKemasan,
    handleCloseAddNewItem,
    handleAddNewItem,
    newCustomer,
    setNewCustomer,
    editRunner,
    setEditRunner,
    editBerat,
    setEditBerat,
    editLevel,
    setEditLevel,
    editBahanBaku,
    setEditBahanBaku,
    editCrusher,
    setEditCrusher,
    editPewarna,
    setEditPewarna,

    editLevel1,
    setEditLevel1,
    editLevel2,
    setEditLevel2,
    editLevel3,
    setEditLevel3,
    editPendukung1,
    setEditPendukung1,
    editPendukung2,
    setEditPendukung2,
    editPendukung3,
    setEditPendukung3,
    foundObject,
    dataRestructure,

    isPinOpen,
    setIsPinOpen,
    isPin,
    setIsPin,
    editHarga,
    setEditHarga,
    dataListPewarna,
    editKomposisiMaba,
    setEditKomposisiMaba,
    optionListBahanBaku,
    optionListPewarna,
    optionListCrusher,

    popUpExportPenggunaanBahan,
    setPopUpExportPenggunaanBahan,
    typeExportPenggunaanBahan,
    setTypeExportPenggunaanBahan,
    handleExportLaporanFg,
    handleExportLaporanRunner,
    handleExportLaporanNgProduk,
    handleExportInventory,
    handleExportBahanBaku,
  };
};
